module.exports = __webpack_public_path__ + "static/media/envelope.77e32e44.svg";